import type { FC } from 'react';
import { Clock } from 'lucide-react';
import { Card, CardContent, CardTitle, CardDescription } from '@ui/card';
import { cn } from '@shared/lib/utils';
import type {
  ShowInfoByIdResponse,
  VenueInfoResponse,
} from 'src/modules/dateSelection/models/show.interface';

interface DetailEventsProps {
  variant?: 'default' | 'compact';
  className?: string;
  isItFirstStep: boolean;
  showInfoById?: ShowInfoByIdResponse;
  venueInfo: VenueInfoResponse | null;
}

export const DetailEvents: FC<DetailEventsProps> = ({
  variant = 'default',
  className,
  isItFirstStep,
}) => {
  const isCompact = variant === 'compact';

  return (
    <div className={cn('lg:col-span-2', className)}>
      {/* Сетка с деталями мероприятия */}
      <div
        className={cn(
          'flex items-center',
          isCompact ? 'flex-row gap-4 flex-wrap' : 'grid grid-cols-1 md:grid-cols-2 gap-6'
        )}
      >
        {/* Успейте забронировать */}
        {!isItFirstStep && (
          <Card className={cn(isCompact ? 'flex-1 min-w-40' : '', 'h-full')}>
            <CardContent className={cn('p-4 h-full flex items-center', isCompact && 'py-2')}>
              <div className="flex items-center gap-3">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-surface-card-muted">
                  <Clock className="w-5 h-5" />
                </div>
                <div>
                  <CardTitle className={cn('text-base mb-1', isCompact && 'text-sm mb-0')}>
                    Успейте забронировать
                  </CardTitle>
                  <CardDescription className={cn('text-sm', isCompact && 'text-xs')}>
                    Таймер лока
                  </CardDescription>
                </div>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};
